<template>
  <transition name="van-slide-down">
    <div v-show="isShow" class="top-notice">
      <div :style="{ left: left + 'px' }" class="bullet">
        <span class="icontemp notice"></span>
        <span class="notice-content">{{ message }}</span>
      </div>
      <span class="icontemp stemp-close close" @click="close()"></span>
    </div>
  </transition>
</template>
<script>
import { buildNoticeMethod, mounted } from "../../common/notice";
import { $subscriber } from "fire-wind-water";
import $ from "jquery";

export default {
  name: "TopNotice",
  data() {
    return {
      message: "这是顶部消息",
      isShow: false,
      left: "-1000",
      joinMessage: {},
      playId: "",
      cleartimer: false,
      outTimeList: [],
      intervalList: []
    };
  },
  watch: {
    isShow() {
      $subscriber.emit("toggleNotifyStatus", this.isShow);
    }
  },
  methods: buildNoticeMethod({
    show() {
      this.isShow = true;
    },
    close() {
      this.isShow = false;
    },
    //消息内容，循环次数默认3
    notify(messageObj, type) {
      let self = this;
      self.left = parseInt($(".top-notice").css("width"));

      if (type === "onNotificationDelete") {
        // 判断是否是撤回
        if (messageObj._id === self.playId) {
          self.cleartimer = true;
          if (self.intervalList.length > 0) {
            self.intervalList.forEach(item => {
              clearInterval(item);
            });
            self.intervalList = [];
          }
          if (self.outTimeList.length > 0) {
            self.outTimeList.forEach(item => {
              clearTimeout(item);
            });
            self.outTimeList = [];
          }
          self.close();
        }
      } else {
        // 清除定时器
        self.cleartimer = true;
        if (self.intervalList.length > 0) {
          self.intervalList.forEach(item => {
            clearInterval(item);
          });
          self.intervalList = [];
        }
        if (self.outTimeList.length > 0) {
          self.outTimeList.forEach(item => {
            clearTimeout(item);
          });
          self.outTimeList = [];
        }
        setTimeout(() => {
          self.cleartimer = false;
          if (type === "initNotifications") {
            if (!messageObj.deleted) {
              if (messageObj.category === "after_join") {
                // 按时长播放
                let validPeriod =
                  new Date(messageObj.valid_time).getTime() -
                  new Date().getTime();
                if (validPeriod > 0) {
                  self.message = messageObj.content;
                  self.playId = messageObj._id;
                  self.playTimer();
                  self.outTimeList.push(
                    setTimeout(() => {
                      self.playTimer(0); // 清除定时
                      self.cleartimer = true;
                    }, validPeriod)
                  );
                }
              } else if (messageObj.category === "loop") {
                // 循环播放
                self.message = messageObj.content;
                self.playId = messageObj._id;
                self.playTimer(messageObj.times);
                let loopValidPeriod =
                  messageObj.valid_period * 60 * 1000 +
                  messageObj.times * 3 * 1000;
                self.intervalList.push(
                  setInterval(function() {
                    self.left = parseInt($(".top-notice").css("width"));
                    self.playTimer(messageObj.times);
                  }, loopValidPeriod)
                );
              }
            }
          } else if (type === "onNotification") {
            // 发布广播
            self.message = messageObj.content;
            self.playId = messageObj._id;
            if (messageObj.category === "immediate") {
              // 按次播放
              self.playTimer(messageObj.times);
            } else if (messageObj.category === "after_join") {
              // 按时长播放
              let validPeriod = messageObj.valid_period * 60 * 1000;
              self.playTimer();
              self.outTimeList.push(
                setTimeout(() => {
                  self.playTimer(0); // 清除定时
                  self.cleartimer = true;
                }, validPeriod)
              );
            } else if (messageObj.category === "loop") {
              // 循环播放
              self.playTimer(messageObj.times);
              let loopValidPeriod =
                messageObj.valid_period * 60 * 1000 +
                messageObj.times * 3 * 1000;
              self.intervalList.push(
                setInterval(function() {
                  self.left = parseInt($(".top-notice").css("width"));
                  self.playTimer(messageObj.times);
                }, loopValidPeriod)
              );
            }
          }
        }, 10);
      }
    },
    playTimer(num) {
      let self = this;
      let times = 0;
      if (num !== 0) {
        self.show();
      }
      let timer = setInterval(function() {
        self.left = self.left - 1;
        if (self.left < 0 - parseInt($(".bullet").css("width")) && num !== 0) {
          self.left = parseInt($(".top-notice").css("width"));
          times++;
        }
        if (times == num) {
          self.left = -1000;
          clearInterval(timer);
          self.close();
        }
        if (self.cleartimer) {
          clearInterval(timer);
        }
      }, 8);
    }
  }),
  created() {},
  mounted() {
    let self = this;
    mounted(self);
  }
};
</script>
